import Configurator from "./configurator/configurator";

new Configurator().init();
